import { CardCvcElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';
import { lang } from '@umu/ukit-lang';
import React, { useState } from 'react';
import type { StripeChangeEvent } from '../../interface';
import './index.scss';

const cardElementOptions = {
    style: {
        base: {
            'color': '#32325d',
            'fontFamily': 'Arial, sans-serif',
            'fontSmoothing': 'antialiased',
            'fontSize': '16px',
            '::placeholder': {
                color: '#32325d',
            },
        },
        invalid: {
            fontFamily: 'Arial, sans-serif',
            color: '#fa755a',
            iconColor: '#fa755a',
        },
    },
};

interface PaymentFormProps {
    onCardChange?: (event: StripeChangeEvent) => void;
    onCardNumberChange?: (event: StripeChangeEvent) => void;
    onCardExpiryChange?: (event: StripeChangeEvent) => void;
    onCardCvcChange?: (event: StripeChangeEvent) => void;
    formRef?: React.RefObject<HTMLFormElement>;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
    onCardNumberChange,
    onCardExpiryChange,
    onCardCvcChange,
    formRef,
}) => {
    const [cardError, setCardError] = useState<string | null>(null);

    const handleCardNumberChange = (event: StripeChangeEvent) => {
        if (event.error) {
            setCardError(event.error.message);
        } else {
            setCardError(null);
        }

        // 只调用专用的卡号变更回调
        onCardNumberChange?.(event);
    };

    const handleCardExpiryChange = (event: StripeChangeEvent) => {
        if (event.error) {
            setCardError(event.error.message);
        } else {
            setCardError(null);
        }

        // 只调用专用的有效期变更回调
        onCardExpiryChange?.(event);
    };

    const handleCardCvcChange = (event: StripeChangeEvent) => {
        if (event.error) {
            setCardError(event.error.message);
        } else {
            setCardError(null);
        }

        // 只调用专用的CVC变更回调
        onCardCvcChange?.(event);
    };

    return (
        <div className="payment-form-container">
            <form ref={formRef}>
                <div className="payment-form-label">{lang('付款信息')}</div>
                <div className="card-content">
                    <div className="card-number-container">
                        <CardNumberElement
                            options={{ ...cardElementOptions, placeholder: lang('卡号') }}
                            className="card-element"
                            onChange={handleCardNumberChange}
                        />
                    </div>
                    <div className="card-row">
                        <div className="card-date-container">
                            <CardExpiryElement
                                options={{ ...cardElementOptions, placeholder: lang('月/年') }}
                                className="card-element"
                                onChange={handleCardExpiryChange}
                            />
                        </div>
                        <div className="card-cvc-container">
                            <CardCvcElement
                                options={{ ...cardElementOptions, placeholder: lang('CVC') }}
                                className="card-element"
                                onChange={handleCardCvcChange}
                            />
                        </div>
                    </div>
                    {cardError && <div className="card-error">{cardError}</div>}
                </div>
            </form>
        </div>
    );
};

export default React.memo(PaymentForm);
